export default __webpack_public_path__ + "media/images/users/user-james-wilkinson-70x70-eeb58656736987630df6472f2d11dca4.jpg";